





















































































































































































































































































































































































































































































































































































































































































































































import {
  CheckCircleFilledIcon,
  CloseCircleFilledIcon,
  LoadingIcon,
  TimeIcon,
  HelpCircleIcon,
  InfoCircleIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';
import { computed, defineComponent, reactive, ref, watch, onUnmounted, getCurrentInstance } from '@vue/composition-api';
import { Route } from 'vue-router';
import FeatureMask from '@/renderer/components/common/Mask.vue';
import AccountLink from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/AccountLink.vue';
import SyncTaskList from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/SyncTaskList.vue';
import WeworkSelectorDialog from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/WeworkSelectorDialog.vue';
import WeworkAssociation from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/WeworkAssociation.vue';
import OrganizationAssociation from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/OrganizationAssociation.vue';
import SSOAssociation from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/SSOAssociation.vue';
import LdapAssociation from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/LdapAssociation.vue';
import CasAssociation from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/CasAssociation.vue';
import SupwisdomAssociation from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/SupwisdomAssociation.vue';
import OauthorOIDCAssociation from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/OauthorOIDCAssociation.vue';
import WeworkDelegate from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/WeworkDelegate.vue';
import WeworkDelegateConfigInfo from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/WeworkDelegateConfigInfo.vue';
import RemoveConfigConfirm from '@/renderer/views/desktop/ManageConsole/AccountAssociation/components/RemoveConfigConfirm.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import syncWeworkHanlder from '@/renderer/views/desktop/ManageConsole/AccountAssociation/composition/syncWeworkHandler';
import accountAssociationHandler from '@/renderer/views/desktop/ManageConsole/AccountAssociation/composition/accountAssociationHandler';
import { httpUrl } from '@/renderer/scripts/http';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import tips from '@/renderer/scripts/utils/tips';
import { SMH } from '@/renderer/scripts/smh';
import store from '@/renderer/store/index';
import user from '@/renderer/scripts/utils/user';
import { IS_BROWSER } from '@/common/constant/platform';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';
import SMHErrorCodeMap from '@/renderer/scripts/utils/errorCode/smhErrorCodeMap';
import { AccountProtocolParams } from '@/renderer/scripts/libs/smh-sdk-class/typings';

type WeworkConfigParams = SMH.WeworkConfigParams & {
  [key: string]: string | boolean | number | undefined;
};
type StatusMap = Record<
  number,
  {
    code: number;
    message: string;
    icon: string;
    class: string;
  }
>;

const statusMap: StatusMap = {
  0: {
    code: 0,
    message: '',
    class: '',
    icon: '',
  },
  200: {
    code: 200,
    message: i18n_t('同步成功'),
    class: 'success',
    icon: 'check-circle-filled',
  },
  202: {
    code: 202,
    class: 'running',
    message: i18n_t('同步中'),
    icon: 'loading',
  },
  207: {
    code: 207,
    class: 'error',
    message: i18n_t('同步失败'),
    icon: 'close-circle-filled',
  },
  400: {
    code: 400,
    class: 'error',
    message: i18n_t('同步失败'),
    icon: 'close-circle-filled',
  },
  500: {
    code: 500,
    class: 'error',
    message: i18n_t('同步失败，服务器错误'),
    icon: 'close-circle-filled',
  },
};

export default defineComponent({
  components: {
    CheckCircleFilledIcon,
    CloseCircleFilledIcon,
    LoadingIcon,
    TimeIcon,
    HelpCircleIcon,
    InfoCircleIcon,
    SSOAssociation,
    LdapAssociation,
    CasAssociation,
    OauthorOIDCAssociation,
    SupwisdomAssociation,
    WeworkSelectorDialog,
    WeworkAssociation,
    WeworkDelegate,
    WeworkDelegateConfigInfo,
    RemoveConfigConfirm,
    OrganizationAssociation,
    SyncTaskList,
    AccountLink,
    FeatureMask,
  },
  filters: {
    ConfigFormValidateFormatter(code: string) {
      const format: Record<string, string> = {
        success: i18n_t('配置生效'),
        error: i18n_t('配置失败'),
        none: i18n_t('未关联'),
        // 代开发应用
        installed: i18n_t('配置中'),
        // 已授权未配置
        authorized: i18n_t('审批中'),
        // 已配置未上线
        rejected: i18n_t('审批未通过,未获取授权信息'),
        // 已配置但被驳回
        online: i18n_t('审批完成'),
        // 已上线未分配可见范围
        active: i18n_t('配置生效'), // 完全完成
      };

      return format[code];
    },
  },
  // 组件路由守卫：本页未保存则拦截路由跳转
  beforeRouteLeave(to: Route, from: Route, next: Function) {
    const notSaveTips = i18n_t('确认离开当前页面？未保存的数据将会丢失。');
    const { isLogined } = store.getters;
    if (!isLogined) {
      // 同步后用户被冻结而踢出登录，此时直接退出登录不需弹窗
      next();
      return;
    }
    if (!this.disableSave) {
      const dialog = CustomDialog.confirm({
        header: i18n_t('提示'),
        body: notSaveTips,
        theme: 'warning',
        onConfirm: async () => {
          if (dialog.hide) {
            dialog.hide();
          }
          next();
        },
        onCancel: () => {
          // 不离开页面
        },
      });
    } else {
      next();
    }
  },
  setup(props, context) {
    const {
      showWeworkSelector,
      showWework,
      showWeworkDelegate,
      showOrganization,
      showSSO,
      originData,
      modifyData,
      showWeworkDelegateConfigInfo,
      configStatusTips,
      disableOperate,
      noneAuthActive,
      anyLoginActive,
      anySyncActive,
      disableSave,
      methods: associationMethods,
    } = accountAssociationHandler();
    const { show: showSyncList, latestTask, methods: syncMethods } = syncWeworkHanlder();
    const lastestTaskObj = computed(() => {
      let statusCode = latestTask.value?.status as number;
      // 错误码4开头代表同步失败，5开头代表服务器，统一处理避免遗漏
      if (Math.round(statusCode / 100) === 5) statusCode = 500;
      if (Math.round(statusCode / 100) === 4) statusCode = 400;
      const creationTime = latestTask.value?.creationTime as string;
      const taskObj = { creationTime, status: statusMap[statusCode || 0] };
      if (latestTask.value?.result) {
        try {
          const info = latestTask.value.result as SMH.SyncWeworkOrgResultData;
          if (info.failedItems?.length && info.failedItems[0]?.code) {
            taskObj.status.message = SMHErrorCodeMap[info.failedItems[0].code] || taskObj.status.message;
          }
        } catch (err) {
          logger.ui.error('lastestTaskObj get message error', err);
        }
      }
      // 关联解除对应的同步状态要重置
      const { syncWay } = modifyData;
      if (
        (syncWay === 'wework' && disableOperate.weworkLogin) ||
        (syncWay === 'yufu' && disableOperate.IDaasSync) ||
        (syncWay === 'openLdap' && disableOperate.ldapLogin) ||
        (syncWay === 'windowsAd' && disableOperate.windowsAdLogin) ||
        (syncWay === 'supwisdom' && disableOperate.supwisdomSync) ||
        syncWay === ''
      ) {
        Object.assign(taskObj, { creationTime: '', status: statusMap[0] });
      }
      return taskObj;
    });

    const showConfirm = ref(false);
    const confirmType = ref('wework');
    // 非企业版屏蔽功能按钮
    const featureNotSupported = computed(() => store.getters.editionFlag !== 'enterprise');
    // 非企业版、同步中、同步方式为空、同步方式所支持的配置项不生效（已解除）则：以上几种情况禁止同步
    const disableSyncNow = computed(
      () =>
        featureNotSupported.value ||
        !modifyData.syncWay ||
        lastestTaskObj.value?.status?.code === 202 ||
        (modifyData.syncWay === 'yufu' && disableOperate.IDaasSync) ||
        (modifyData.syncWay === 'wework' && disableOperate.weworkLogin) ||
        (modifyData.syncWay === 'openLdap' && disableOperate.ldapLogin) ||
        (modifyData.syncWay === 'windowsAd' && disableOperate.windowsAdLogin) ||
        (modifyData.syncWay === 'supwisdom' && disableOperate.supwisdomSync),
    );

    // 非企业版、同步方式为空、同步方式所支持的配置项不生效（已解除）则：以上几种情况禁止查看同步记录
    const disableSyncRecord = computed(
      () =>
        featureNotSupported.value ||
        !modifyData.syncWay ||
        (modifyData.syncWay === 'yufu' && disableOperate.IDaasSync) ||
        (modifyData.syncWay === 'wework' && disableOperate.weworkLogin) ||
        (modifyData.syncWay === 'openLdap' && disableOperate.ldapLogin) ||
        (modifyData.syncWay === 'windowsAd' && disableOperate.windowsAdLogin) ||
        (modifyData.syncWay === 'supwisdom' && disableOperate.supwisdomSync),
    );

    // 关联卡片：!noneAuthActive标识有任意一种关联成功，除了企业微信关联需要额外根据状态显示，其它的关联方式是成功了就会显示；
    const showAccountLinkCard = computed(
      () => !noneAuthActive.value || configStatusTips.weworkValidate.code !== 'none',
    );

    // 弹窗
    const showAuthDialog = ref(false);
    const showLDAPDialog = ref(false);
    const showWindowsAdDialog = ref(false);
    const showCASDialog = ref(false);
    const showOauthDialog = ref(false);
    const showOIDCDialog = ref(false);
    const showSupwisdomDialog = ref(false);
    // 是否启用了sso登录
    const ssoEnable = computed(() => !!store.getters.ssoWay || store.getters.enableYufuLogin);
    const ssoChecked = ref(false);
    const ssoCheckedEnable = computed(
      () =>
        !disableOperate.SSOLogin || !disableOperate.casLogin || !disableOperate.oauthLogin || !disableOperate.oidcLogin,
    );

    // 配置测试
    const ldapTestResult = ref('');
    const configTestDetail = reactive<any>({});
    const casTestResult = ref('');
    const oauthTestResult = ref('');
    const oidcTestResult = ref('');
    const supwisdomTestResult = ref('');

    // 表单数据: 后续合并入组件
    const ldapForm = reactive<any>({});
    const casForm = reactive<any>({});
    const oauthForm = reactive<any>({});

    // sso登录协议选项
    const ssoOptions = computed(() => {
      const options = [];
      if (!disableOperate.oauthLogin) {
        options.push({ label: i18n_t('OAuth协议'), value: 'oauth' });
      }
      if (!disableOperate.oidcLogin) {
        options.push({ label: i18n_t('OIDC协议'), value: 'oidc' });
      }
      if (!disableOperate.casLogin) {
        options.push({ label: i18n_t('CAS协议'), value: 'cas' });
      }
      if (!disableOperate.SSOLogin) {
        options.push({ label: i18n_t('IDaas协议'), value: 'yufu' });
      }
      return options;
    });
    // openLdap和windowsAd选项
    const ldapOrAdOptions = computed(() => {
      const options = [];
      if (!disableOperate.ldapLogin) {
        options.push({ label: 'Open LDAP', value: 'openLdap' });
      }
      if (!disableOperate.windowsAdLogin) {
        options.push({ label: 'Windows AD', value: 'windowsAd' });
      }
      return options;
    });

    const accountAssociationRef = ref<HTMLElement | null>(null);

    const methods = {
      async initData() {
        // 检查当前企业支持哪些协议
        await store.dispatch('getSupportProtocolList');
        if (store.getters.supportProtocols.includes('wework')) {
          await associationMethods.getWeworkConfig();
        }
        if (store.getters.supportProtocols.includes('yufu')) {
          await associationMethods.getIDaasConfig();
        }
        await associationMethods.getAccountProtocol();
        // 进入页面后重新获取store中的值(解决多个人操作的时候store数据不一致的问题)
        store.dispatch('GetOrgInfo', store.getters.orgId);
        ssoChecked.value = ssoEnable.value;
      },
      handleWeorkConfig(data: WeworkConfigParams) {
        Object.assign(modifyData.weworkConfig, data);
        associationMethods.getWeworkConfig();
        tips.success(i18n_t('已激活关联端 登录同步 与 组织架构同步 相关功能'));
        // confirmType.value = 'wework';
        // showConfirm.value = true;
      },

      handleIDaasConfig(data: SMH.IDaasConfigParams) {
        Object.assign(modifyData.idaasConfig, data);
        associationMethods.getIDaasConfig();
        tips.success(i18n_t('已激活关联端 组织架构同步 相关功能'));
      },
      handleSSOConfig(data: SMH.IDaasConfigParams) {
        Object.assign(modifyData.idaasConfig, data);
        associationMethods.getIDaasConfig();
        tips.success(i18n_t('已激活关联端 登录同步 相关功能'));
        // confirmType.value = 'idaas';
        // showConfirm.value = true;
      },
      handleSave() {
        // 更改同步方式的同时需要重新获取同步记录
        associationMethods.handleSave();
      },
      showSyncDialog() {
        // FIX: 由于打开同步日志抽屉将当前的父元素设置为禁止滚动，因此要将抽屉的挂载元素滚动到顶从而阻止抽屉头部由于滚动被隐藏的问题
        accountAssociationRef.value?.scrollTo({ top: 0 });
        showSyncList.value = true;
      },
      async onTriggerSyncNow() {
        // 数据来源及其对应的配置成功时方可同步
        tips.info(i18n_t('正在同步中，同步详情可前往同步记录查看。'));
        let configType: CoFile.SyncType = '';
        let syncWay;
        if (modifyData.syncWay === 'yufu' && configStatusTips.idaasValidate.code === 'success') {
          configType = 'SyncYufuOrg';
        } else if (modifyData.syncWay === 'wework' && configStatusTips.weworkValidate.code === 'success') {
          configType = 'SyncWeworkOrg';
        } else if (
          ['openLdap', 'windowsAd'].includes(modifyData.syncWay) &&
          (configStatusTips.ldapValidate.code === 'success' || configStatusTips.windowsAdValidate.code === 'success')
        ) {
          configType = 'SyncAccountOrg';
          syncWay = modifyData.syncWay;
        } else if (modifyData.syncWay === 'supwisdom' && configStatusTips.supwisdomValidate.code === 'success') {
          configType = 'SyncAccountOrg';
          syncWay = 'supwisdom';
        }

        const syncTaskListRef: any = context.refs.syncTaskList;
        await syncMethods.triggerSyncNow({
          action: configType,
          syncWay,
          taskReadyFn: () => {
            // 触发任务时发现任务列表正在展示 需要手动刷新
            if (syncTaskListRef) {
              syncTaskListRef.refresh();
            }
          },
        });
        syncMethods.pullList(configType);
        // 任务结束时发现任务列表正在展示 需要手动刷新
        if (syncTaskListRef) {
          syncTaskListRef.refresh();
        }
      },
      async handleWeworkLogin(val: boolean) {
        // 如果企微没有任何同步记录，则需提示用户先同步才可以勾选企微扫码登录
        const isSync = await syncMethods.isSyncBefore('SyncWeworkOrg');
        if (val && !isSync) {
          modifyData.enableWeworkLogin = false;
          const dialog = CustomDialog.confirm({
            header: i18n_t('需同步组织架构'),
            body: i18n_t(
              '未同步组织架构，首次开启需进行一次企业微信的组织架构同步操作，同步名单内成员即可支持微信扫码登录。',
            ),

            theme: 'info',
            confirmBtn: i18n_t('立即同步'),
            onConfirm: () => {
              modifyData.syncWay = 'wework';
              methods.onTriggerSyncNow();
              if (dialog.hide) {
                dialog.hide();
              }
            },
          });
        }
      },
      async handleLdapLogin(val: boolean, type: string) {
        // 如果OpenLdap和windowsAd没有任何同步记录，则需提示用户先同步才可以勾选openLdap/windowsAd登录
        const isSync = await syncMethods.isSyncBefore('SyncAccountOrg');
        if (val && !isSync) {
          if (type === 'openLdap') {
            modifyData.enableOpenLdapLogin = false;
          } else if (type === 'windowsAd') {
            modifyData.enableWindowsAdLogin = false;
          }
          const dialog = CustomDialog.confirm({
            header: i18n_t('需同步组织架构'),
            body: i18n_t('未同步组织架构，首次开启需进行一次组织架构同步操作，同步名单内成员即可登录。'),
            theme: 'info',
            confirmBtn: i18n_t('立即同步'),
            onConfirm: () => {
              modifyData.syncWay = type;
              methods.onTriggerSyncNow();
              if (dialog.hide) {
                dialog.hide();
              }
            },
          });
        }
      },
      confirmClose() {
        showConfirm.value = false;
      },
      async confirmRemove(type: string) {
        /**
         * 移除关联分三种情况（如果选中的同步和登录被移除）
         *  1.移除同步：需要重置同步记录，同时请求后台重置同步方式
         *  2.移除登录: 需要重置ssoWay或者对应的enableLogin值
         *  3.移除同步以及登录：需要同时处理以上两种情况
         */
        switch (type) {
          case 'idass-data':
            await associationMethods.closeYufuConfig('sync');
            await associationMethods.getIDaasConfig();
            break;
          case 'idass-auth':
            await associationMethods.closeYufuConfig('sso');
            await associationMethods.getIDaasConfig();
            break;
          case 'wework':
            await associationMethods.closeWeworkConfig();
            await associationMethods.getWeworkConfig();
            break;
          case 'openLdap':
          case 'windowsAd':
          case 'oauth':
          case 'oidc':
          case 'cas':
          case 'supwisdom':
            await associationMethods.removeAccountProtocol({ protocol: type });
            await associationMethods.getAccountProtocol();
            break;
          default:
            break;
        }
      },
      verifyLogin() {
        user.signOut();
      },
      // 点击企微配置的关联
      openWework() {
        /**
         * 可以使用自建应用
         * 1、私有化里只能使用自建应用
         * 2、公有云里只有白名单用户才可以使用自建应用【store.getters.allowWeworkSelfApp】
         */
        const canUseSelfApp = store.getters.isPrivate || store.getters.allowWeworkSelfApp;
        if (canUseSelfApp && !store.getters.isPrivate && !modifyData.weworkConfig.status) {
          // 配置为空 && 企微自建应用白名单 && 公有云：展示选择弹窗
          showWeworkSelector.value = true;
        } else if ((canUseSelfApp && modifyData.weworkConfig.status === 'active') || store.getters.isPrivate) {
          // 已配置好自建应用 || 私有化下，打开自建应用配置信息
          showWework.value = true;
        } else {
          // 展示代开发弹窗
          showWeworkDelegate.value = true;
        }
      },
      openWeworkConfig() {
        const isSelfConfig = originData.weworkConfig.type === 'self' && originData.weworkConfig.status === 'active';
        const isDelegateConfig =
          originData.weworkConfig.type === 'delegate' && originData.weworkConfig.status === 'active';
        if (isDelegateConfig) {
          showWeworkDelegateConfigInfo.value = true;
        } else if (isSelfConfig) {
          showWework.value = true;
        }
      },
      // 展示对应的关联弹窗
      showAssociateDialog(type: string) {
        showAuthDialog.value = false;
        switch (type) {
          case 'idaas-data':
            showOrganization.value = true;
            break;
          case 'idaas-auth':
            showSSO.value = true;
            break;
          case 'wecom':
            methods.openWework();
            break;
          case 'openLdap':
            ldapTestResult.value = '';
            showLDAPDialog.value = true;
            break;
          case 'windowsAd':
            ldapTestResult.value = '';
            showWindowsAdDialog.value = true;
            break;
          case 'cas':
            casTestResult.value = '';
            showCASDialog.value = true;
            break;
          case 'oauth':
            oauthTestResult.value = '';
            showOauthDialog.value = true;
            break;
          case 'oidc':
            oidcTestResult.value = '';
            showOIDCDialog.value = true;
            break;
          case 'supwisdom':
            supwisdomTestResult.value = '';
            showSupwisdomDialog.value = true;
            break;
          default:
            break;
        }
      },
      closeAllAssociateDialog() {
        showLDAPDialog.value = false;
        showWindowsAdDialog.value = false;
        showOrganization.value = false;
        showSSO.value = false;
        casTestResult.value = '';
        oauthTestResult.value = '';
        oidcTestResult.value = '';
        showCASDialog.value = false;
        showOauthDialog.value = false;
        showSupwisdomDialog.value = false;

        ldapTestResult.value = '';
        casTestResult.value = '';
        supwisdomTestResult.value = '';
        showOIDCDialog.value = false;
      },
      setTestResult(protocol: string, result: string) {
        if (protocol && ['openLdap', 'windowsAd'].includes(protocol)) {
          ldapTestResult.value = result;
        } else if (protocol && protocol === 'cas') {
          casTestResult.value = result;
        } else if (protocol && protocol === 'supwisdom') {
          supwisdomTestResult.value = result;
        } else if (protocol && protocol === 'oauth') {
          oauthTestResult.value = result;
        } else if (protocol && protocol === 'oidc') {
          oidcTestResult.value = result;
        }
      },
      async testConfig(config: AccountProtocolParams) {
        const { protocol } = config;
        if (protocol) {
          methods.setTestResult(protocol, 'testing');
        }
        return new Promise<string>((resolve, reject) => {
          associationMethods
            .testAccountProtocol(config)
            .then(res => {
              const { testResult, testDetail } = res;
              if (['success', 'timeout'].includes(testResult)) {
                if (protocol) {
                  methods.setTestResult(protocol, testResult);
                }
                if (protocol && ['openLdap', 'windowsAd', 'supwisdom'].includes(protocol)) {
                  Object.assign(configTestDetail, testDetail);
                }
              }
              resolve(testResult);
            })
            .catch(error => {
              const { testResult, testDetail } = error;
              if (testResult === 'fail') {
                if (protocol) {
                  methods.setTestResult(protocol, testResult);
                }
                if (protocol && ['openLdap', 'windowsAd', 'supwisdom'].includes(protocol)) {
                  Object.assign(configTestDetail, testDetail);
                }
              }
              reject(error);
            });
        });
      },
      // 保存配置
      async saveConfig(config: AccountProtocolParams, needTest?: boolean, needClose?: boolean) {
        methods.testConfig(config).then(async res => {
          await associationMethods.updateAccountProtocol(config);
          await associationMethods.getAccountProtocol();
          methods.closeAllAssociateDialog();
          tips.success(i18n_t('保存成功'));
        });
      },
      // 打开用户使用手册
      openCofileGuide() {
        dispatchRouter(httpUrl.staticCDNURLMap.userManualUrl);
      },
    };
    if (store.getters.editionFlag === 'enterprise') {
      methods.initData();
    }

    watch(
      () => modifyData.syncWay,
      (val: string) => {
        if (val === 'yufu') {
          syncMethods.pullList('SyncYufuOrg');
        } else if (val === 'wework') {
          syncMethods.pullList('SyncWeworkOrg');
        } else if (['openLdap', 'windowsAd', 'supwisdom'].includes(val)) {
          syncMethods.pullList('SyncAccountOrg');
        } else if (val === '') {
          syncMethods.reset();
        }
      },
      { immediate: true },
    );

    watch(
      () => ssoEnable.value,
      (val: boolean) => {
        ssoChecked.value = val;
      },
    );

    watch(
      () => ssoChecked.value,
      (val: Boolean) => {
        if (val) {
          modifyData.ssoWay = originData.ssoWay || ssoOptions.value[0].value;
        } else {
          modifyData.ssoWay = '';
          modifyData.enableYufuLogin = false;
        }
      },
    );

    if (IS_BROWSER) {
      // 拦截当前页面刷新和关闭
      const onBeforeunload = (event: BeforeUnloadEvent) => {
        if (!disableSave.value) {
          const notSaveTips = i18n_t('确认离开当前页面？未保存的数据将会丢失。');
          const e = event || window.event;
          e.returnValue = notSaveTips;
          e.preventDefault();
          return notSaveTips;
        }
        return null;
      };
      window.addEventListener('beforeunload', onBeforeunload);
      onUnmounted(() => {
        window.removeEventListener('beforeunload', onBeforeunload);
      });
    }

    // 切换身份
    user.on('switch-org-started', () => {
      methods.initData();
    });
    onUnmounted(() => {
      user.off('switch-org-started', '*');
    });
    return {
      showWeworkSelector,
      showWework,
      showWeworkDelegate,
      showWeworkDelegateConfigInfo,
      showOrganization,
      showConfirm,
      showSSO,
      showSyncList,

      showAuthDialog,
      showLDAPDialog,
      showWindowsAdDialog,
      showCASDialog,
      showOauthDialog,
      showSupwisdomDialog,
      showOIDCDialog,
      showAccountLinkCard,
      ssoChecked,
      ssoCheckedEnable,
      ldapForm,
      casForm,
      oauthForm,
      ssoOptions,
      ldapOrAdOptions,
      ldapTestResult,
      configTestDetail,
      casTestResult,
      supwisdomTestResult,
      oauthTestResult,
      oidcTestResult,

      disableSave,
      disableOperate,
      noneAuthActive,
      anyLoginActive,
      anySyncActive,
      disableSyncNow,
      disableSyncRecord,
      confirmType,
      originData,
      modifyData,
      configStatusTips,
      featureNotSupported,
      associationMethods,
      lastestTaskObj,
      accountAssociationRef,
      ...methods,
    };
  },
});
